maybeDependOnExistenceOfEntity